module.exports = __webpack_public_path__ + "img/reclaim.fa9edad8.svg";